angular
  .module('inhouseNoticeView')
  .component('inhouseNoticeView', {
    template: require('./inhouse-notice-view.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function inhouseNoticeViewViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'inhouse';
        $rootScope.menu = 'inhouseNotice';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.tbNoticeId = $rootScope.inhouseNoticeId;
        $resource(`${APIURL}/admin/inhouseNotice/${this.tbNoticeId}`).get().$promise
          .then((data) => {
            this.notice = data;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.list = () => {
          $location.path('/inhouse/notice/');
        };
        this.modify = () => {
          $location.path('/inhouse/notice/edit');
        };
        this.delete = () => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/inhouseNotice/${this.tbNoticeId}`).delete().$promise
            .then(() => {
              alert($translate.instant('삭제되었습니다'));
              $location.path('/inhouse/notice/');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.readEmployees = () => {
          $resource(`${APIURL}/admin/inhouseNotice/${this.tbNoticeId}/reads`).get().$promise
            .then((data) => {
              this.readEmployees = data.employees;
              jQuery('#modal-reads-view').modal('show');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.unreadEmployees = () => {
          $resource(`${APIURL}/admin/inhouseNotice/${this.tbNoticeId}/unreads`).get().$promise
            .then((data) => {
              this.readEmployees = data.employees;
              jQuery('#modal-unreads-view').modal('show');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.readsClose = () => {
          jQuery('#modal-reads').removeClass('fade');
          jQuery('#modal-unreads').removeClass('fade');
          jQuery('#modal-reads-view').modal('hide');
          jQuery('#modal-unreads-view').modal('hide');
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-view/inhouse-notice-view.component.js